import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-98ecd6ba")

_pushScopeId("data-v-98ecd6ba")
const _hoisted_1 = { style: {"background-image":"url('img/landing/ornament.svg')","background-position":"-20px -10px","margin-top":"-80px","margin-bottom":"-200px","padding-top":"76px","position":"inherit"} }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"pt-12 px-4 sm:px-6 lg:px-8 lg:pt-20\" data-v-98ecd6ba><div class=\"text-center\" data-v-98ecd6ba><h2 class=\"text-lg leading-6 font-semibold text-gray-300 uppercase tracking-wider\" data-v-98ecd6ba> Pricing </h2><p class=\"mt-2 text-3xl font-extrabold text-white sm:text-4xl lg:text-5xl\" data-v-98ecd6ba> The right price for your Business </p><p class=\"mt-3 max-w-4xl mx-auto text-xl text-gray-300 sm:mt-5 sm:text-2xl\" data-v-98ecd6ba> Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit numquam eligendi quos odit doloribus molestiae voluptatum. </p></div></div>", 1)
const _hoisted_3 = { class: "mt-16 pb-12 lg:mt-20 lg:pb-20" }
const _hoisted_4 = { class: "relative z-0" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "absolute inset-0 h-5/6 lg:h-2/3" }, null, -1)
const _hoisted_6 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "relative lg:grid lg:grid-cols-7" }
const _hoisted_8 = { class: "mx-auto bg-white rounded-3xl max-w-md lg:mx-0 lg:max-w-none lg:col-start-1 lg:col-end-3 lg:row-start-2 lg:row-end-3" }
const _hoisted_9 = { class: "h-full flex flex-col rounded-3xl shadow-lg overflow-hidden lg:rounded-3xl" }
const _hoisted_10 = { class: "flex-1 flex flex-col" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-white px-6 py-10\" data-v-98ecd6ba><div data-v-98ecd6ba><h3 class=\"text-center text-2xl font-medium text-gray-900\" id=\"tier-hobby\" data-v-98ecd6ba> Hobby </h3><div class=\"mt-4 flex items-center justify-center\" data-v-98ecd6ba><span class=\"px-3 flex items-start text-6xl tracking-tight text-gray-900\" data-v-98ecd6ba><span class=\"mt-2 mr-2 text-4xl font-medium\" data-v-98ecd6ba> € </span><span class=\"font-extrabold\" data-v-98ecd6ba> 2,49 </span></span><span class=\"text-xl font-medium text-gray-500\" data-v-98ecd6ba> /month </span></div></div></div>", 1)
const _hoisted_12 = { class: "flex-1 flex flex-col justify-between border-gray-100  rounded-3xl p-6 bg-gray-50 sm:p-10 lg:p-6 xl:p-10" }
const _hoisted_13 = {
  role: "list",
  class: "space-y-4"
}
const _hoisted_14 = { class: "flex-shrink-0" }
const _hoisted_15 = { class: "ml-3 text-base font-medium text-gray-500" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "mt-8" }, [
  /*#__PURE__*/_createVNode("div", { class: "rounded-3xl shadow-md" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "block w-full text-center rounded-3xl border border-transparent bg-white px-6 py-3 text-base font-medium text-indigo-600 hover:bg-gray-50",
      "aria-describedby": "tier-hobby"
    }, " Start your trial ")
  ])
], -1)
const _hoisted_17 = { class: "mt-10 max-w-lg mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-start-3 lg:col-end-6 lg:row-start-1 lg:row-end-4" }
const _hoisted_18 = { class: "relative z-10 rounded-3xl shadow-xl bg-white" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"pointer-events-none absolute inset-0 rounded-3xl border-2 border-bp-light\" aria-hidden=\"true\" data-v-98ecd6ba></div><div class=\"absolute inset-x-0 top-0 transform translate-y-px\" data-v-98ecd6ba><div class=\"flex justify-center transform -translate-y-1/2\" data-v-98ecd6ba><span class=\"inline-flex rounded-full bg-indigo-600 px-4 py-1 text-sm font-semibold tracking-wider uppercase text-white\" data-v-98ecd6ba> Most popular </span></div></div><div class=\"bg-white rounded-3xl px-6 pt-12 pb-10\" data-v-98ecd6ba><div data-v-98ecd6ba><h3 class=\"text-center text-3xl font-semibold text-gray-900 sm:-mx-6\" id=\"tier-growth\" data-v-98ecd6ba> Growth </h3><div class=\"mt-4 flex items-center justify-center\" data-v-98ecd6ba><span class=\"px-3 flex items-start text-6xl tracking-tight text-gray-900 sm:text-6xl\" data-v-98ecd6ba><span class=\"mt-2 mr-2 text-4xl font-medium\" data-v-98ecd6ba> € </span><span class=\"font-extrabold\" data-v-98ecd6ba> 4,49 </span></span><span class=\"text-2xl font-medium text-gray-500\" data-v-98ecd6ba> /month </span></div></div></div>", 3)
const _hoisted_22 = { class: "border-gray-100 rounded-3xl pt-10 pb-8 px-6 bg-gray-50 sm:px-10 sm:py-10" }
const _hoisted_23 = {
  role: "list",
  class: "space-y-4"
}
const _hoisted_24 = { class: "flex-shrink-0" }
const _hoisted_25 = { class: "ml-3 text-base font-medium text-gray-500" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "mt-10" }, [
  /*#__PURE__*/_createVNode("div", { class: "rounded-3xl shadow-md" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "block w-full text-center rounded-3xl border border-transparent bg-indigo-600 px-6 py-4 text-xl leading-6 font-medium text-white hover:bg-indigo-700",
      "aria-describedby": "tier-growth"
    }, " € ")
  ])
], -1)
const _hoisted_27 = { class: "mt-10 bg-white rounded-3xl mx-auto max-w-md lg:m-0 lg:max-w-none lg:col-start-6 lg:col-end-8 lg:row-start-2 lg:row-end-3" }
const _hoisted_28 = { class: "h-full flex flex-col rounded-3xl shadow-lg overflow-hidden lg:rounded-3xl" }
const _hoisted_29 = { class: "flex-1 flex flex-col" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-white px-6 py-10\" data-v-98ecd6ba><div data-v-98ecd6ba><h3 class=\"text-center text-2xl font-medium text-gray-900\" id=\"tier-scale\" data-v-98ecd6ba> Scale </h3><div class=\"mt-4 flex items-center justify-center\" data-v-98ecd6ba><span class=\"px-3 flex items-start text-6xl tracking-tight text-gray-900\" data-v-98ecd6ba><span class=\"mt-2 mr-2 text-4xl font-medium\" data-v-98ecd6ba> € </span><span class=\"font-extrabold\" data-v-98ecd6ba> 7.49 </span></span><span class=\"text-xl font-medium text-gray-500\" data-v-98ecd6ba> /month </span></div></div></div>", 1)
const _hoisted_31 = { class: "flex-1 flex flex-col justify-between rounded-3xl border-gray-100 p-6 bg-gray-50 sm:p-10 lg:p-6 xl:p-10" }
const _hoisted_32 = {
  role: "list",
  class: "space-y-4"
}
const _hoisted_33 = { class: "flex-shrink-0" }
const _hoisted_34 = { class: "ml-3 text-base font-medium text-gray-500" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "mt-8" }, [
  /*#__PURE__*/_createVNode("div", { class: "rounded-3xl shadow-md" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "block w-full text-center rounded-3xl border border-transparent bg-white px-6 py-3 text-base font-medium text-indigo-600 hover:bg-gray-50",
      "aria-describedby": "tier-scale"
    }, " subscribe ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckIcon = _resolveComponent("CheckIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode("div", _hoisted_12, [
                    _createVNode("ul", _hoisted_13, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.hobbyFeatures, (feature) => {
                        return (_openBlock(), _createBlock("li", {
                          key: feature,
                          class: "flex items-start"
                        }, [
                          _createVNode("div", _hoisted_14, [
                            _createVNode(_component_CheckIcon, {
                              class: "flex-shrink-0 h-6 w-6 text-green-500",
                              "aria-hidden": "true"
                            })
                          ]),
                          _createVNode("p", _hoisted_15, _toDisplayString(feature), 1)
                        ]))
                      }), 128))
                    ]),
                    _hoisted_16
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_22, [
                  _createVNode("ul", _hoisted_23, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.growthFeatures, (feature) => {
                      return (_openBlock(), _createBlock("li", {
                        key: feature,
                        class: "flex items-start"
                      }, [
                        _createVNode("div", _hoisted_24, [
                          _createVNode(_component_CheckIcon, {
                            class: "flex-shrink-0 h-6 w-6 text-green-500",
                            "aria-hidden": "true"
                          })
                        ]),
                        _createVNode("p", _hoisted_25, _toDisplayString(feature), 1)
                      ]))
                    }), 128))
                  ]),
                  _hoisted_26
                ])
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode("div", _hoisted_31, [
                    _createVNode("ul", _hoisted_32, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.scaleFeatures, (feature) => {
                        return (_openBlock(), _createBlock("li", {
                          key: feature,
                          class: "flex items-start"
                        }, [
                          _createVNode("div", _hoisted_33, [
                            _createVNode(_component_CheckIcon, {
                              class: "flex-shrink-0 h-6 w-6 text-green-500",
                              "aria-hidden": "true"
                            })
                          ]),
                          _createVNode("p", _hoisted_34, _toDisplayString(feature), 1)
                        ]))
                      }), 128))
                    ]),
                    _hoisted_35
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})